const mockEmployee = {
    id: "EMP-001",
    name: "Asha Kumar",
    jobTitle: "Software Engineer",
    personalEmail: "asha.kumar@example.com",
    workEmail: "asha.k@company.com",
    phone: "+91-98765-43210",
    department: "Engineering",
    hireDate: "2022-03-10",
    salary: 850000,
    bonuses: 50000,
    manager: "Ravi Sharma",
    leaveBalance: 12,
    emergencyContact: "Renu Kumar (+91-91234-56789)",
    notes: "High performer",
  };
  
  export default mockEmployee;
  